import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FavoriteIcon from '@material-ui/icons/Favorite';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Menu, Dropdown, Button } from 'antd';
import Link from 'next/link';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import Slider from 'react-slick';
import { countDecimals } from '../../services/common-query';
import moment from 'moment';
import { AspectRatio } from 'react-aspect-ratio';
import { isWebpSupported } from 'react-image-webp/dist/utils';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import {
  collection,
  doc,
  getDocs,
  query,
  where,
  writeBatch,
} from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { showToastMessage } from '../../services/insert-username';
import { checkSpotifyLink, checkAppleLink } from '../../helpers/regex';
import ReactPlayer from 'react-player/lazy';
import AudioComponent from '../Card/AudioComponent';
import router from 'next/router';
import { async } from '@firebase/util';

const useStyles = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
  },
}));
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  dotsClass: 'slick-dots slick-thumb',

  appendDots: (dots) => (
    <div
      style={{
        marginBottom: 34,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        height: 20,
        alignItems: 'flex-start',
      }}
    >
      <div
        onClick={(e) => {
          e.preventDefault();
        }}
        style={{ cursor: 'default' }}
      >
        <ul className="discover-dots-ul"> {dots} </ul>
      </div>
    </div>
  ),
  customPaging: (i) => <div className="dots-discover"></div>,
};

export default function NftsCollectionComponent(props) {
  const classes = useStyles();
  const nftMusicLink = {
    appleMusic: props.ele.appleMusic,
    spotify: props.ele.spotify,
  };
  const { ele, transferToSellingPage } = props;
  const bsvRate = useSelector((state) => state.bsvRateReducer.bsvRate);
  const userDataRedux = useSelector((state) => state.authReducer.userData);

  const [open, setOpen] = useState(false);
  const [spotifyMusicLink, setSpotifyMusicLink] = useState(
    props.ele.spotify || '',
  );
  const [appleMusicLink, setAppleMusicLink] = useState(
    props.ele.appleMusic || '',
  );
  const [isSpotifyLinkValid, setIsSpotifyLinkValid] = useState(true);
  const [isAppleLinkValid, setIsAppleLinkValid] = useState(true);
  const [showRedeemOption, setshowRedeemOption] = useState(false);

  useEffect(() => {
    if (props.ele) {
      if (
        props.subNftDisplay &&
        !props?.ele?.activeInMarketPlace &&
        !props?.ele?.isRedeem
      ) {
        setshowRedeemOption(true);
      } else if (!props.subNftDisplay) {
        if (props.ele.isRedeem) {
          return null;
        }
        if (props.ele.isMultiple && props.ele.canBulkRedeem) {
          setshowRedeemOption(true);
        } else if (
          !props.ele.isMultiple &&
          !props.ele.isRedeem &&
          !props.ele.activeInMarketPlace
        ) {
          setshowRedeemOption(true);
        }
      }
    }
  }, [props.ele, props.subNftDisplay]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (reset = true) => {
    setOpen(false);
    if (reset) {
      setSpotifyMusicLink(props.ele.spotify);
      setAppleMusicLink(props.ele.appleMusic);
      setIsSpotifyLinkValid(true);
      setIsAppleLinkValid(true);
    }
  };

  const musicLink = async (e) => {
    e.preventDefault();
  };

  const isButtonDisable = () => {
    return (
      !isSpotifyLinkValid ||
      !isAppleLinkValid ||
      (nftMusicLink.appleMusic === appleMusicLink &&
        nftMusicLink.spotify === spotifyMusicLink)
    );
  };

  const handleLinks = async () => {
    try {
      let batch = writeBatch(firebaseFireStore);
      let updateMusicLinks = doc(
        firebaseFireStore,
        'musicartNfts',
        props.ele.tokenId,
      );
      batch.update(updateMusicLinks, {
        appleMusic: appleMusicLink,
        spotify: spotifyMusicLink,
      });
      await batch.commit();
      showToastMessage({
        actionType: 'success',
        message: 'Updated successfully',
      });
      props?.updateSelectedNft(props.ele.tokenId, {
        appleMusic: appleMusicLink,
        spotify: spotifyMusicLink,
      });
      handleClose(false);
    } catch (err) {
      showToastMessage({
        actionType: 'error',
        message: 'Something went wrong',
      });
    }
  };

  const menuClicked = (e, index) => {
    // if (e.key === '3') {
    //   props.hanleOpenNotPublicDialog(index, props.ele);
    // } else
    if (e.key === '2') {
      props.setSelectedNftIndex(index);
      props.setnftTransferDialogState(true);
    } else if (e.key === '5') {
      props.setSelectedNftIndex(index);
      props.setRedeemModalIsOpened(true);
      console.log('called redeem nft');
    }
  };
  const skeletonID = 'idofskeleton' + props.ele?.tokenId;
  function showPic(event) {
    setTimeout(() => {
      const matches = document.querySelectorAll(`#${event.target?.alt}`);
      if (matches) {
        matches.forEach((match) => {
          match.style.opacity = 0;
        });
        if (
          document.getElementById(event.target.alt) &&
          document.getElementById(event.target.alt).style &&
          document.getElementById(event.target.alt).style.opacity
        ) {
          document.getElementById(event.target.alt).style.opacity = 0;
        }
      }
    }, 500);
  }

  const isFirstMinter = ele?.issuerID === userDataRedux?.uid;

  const menuDropdown = (index) => (
    <Menu
      className="text-blueGray-700"
      style={{ minWidth: 140 }}
      onClick={(e) => menuClicked(e, index)}
    >
      <Menu.Item className="py-2" key="1">
        <Link
          prefetch={false}
          href={'/nft/' + props.ele.tokenId}
        >
          <a style={{ display: 'block' }}>
            <div className="flex items-center	">
              <EditIcon className="inline-block" />
              <p className="ml-3">
                <span className="font-normal block">View NFT</span>
              </p>
            </div>
          </a>
        </Link>
      </Menu.Item>

      {isFirstMinter && !transferToSellingPage && (
        <Menu.Item className="py-2">
          <div className="flex items-center">
            <EditIcon className="inline-block" />
            <p className="ml-3">
              <span className="front-normal block" onClick={handleClickOpen}>
                Edit music links
              </span>
            </p>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
              <h5
                className="text-lg font-semibold"
                style={{ padding: '18px 24px 10px 24px' }}
              >
                Edit Music Links
              </h5>
              <div className="dialog-close-medium">
                <button
                  className="bg-white text-black my-2 text-lg font-light h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
                  type="button"
                  onClick={handleClose}
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>
              <form className="bg-blueGray-100" onSubmit={musicLink}>
                <DialogContent>
                  <div>
                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      Spotify
                    </label>
                    <input
                      onChange={(e) => {
                        setSpotifyMusicLink(e.target.value);
                      }}
                      onBlur={(e) => {
                        const spotifyValidation = e.target.value;
                        const isSpotifyValid =
                          !spotifyValidation ||
                          checkSpotifyLink(spotifyValidation);
                        setIsSpotifyLinkValid(isSpotifyValid);
                      }}
                      type="text"
                      value={spotifyMusicLink}
                      placeholder="Please enter the link to the song or album on Spotify."
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow-lg focus:outline-none focus:ring w-full ease-linear transition-all duration-150 mb-4"
                    />
                    <div style={{ marginTop: '12.86px' }}>
                      {!isSpotifyLinkValid && (
                        <span
                          className="text-red-500"
                          style={{ position: 'relative', bottom: '15px' }}
                        >
                          Please enter a valid link. It should start with:
                          https://open.spotify.com/
                        </span>
                      )}
                    </div>
                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      Apple
                    </label>
                    <input
                      onChange={(e) => {
                        setAppleMusicLink(e.target.value);
                      }}
                      type="text"
                      value={appleMusicLink}
                      onBlur={(e) => {
                        const appleValidation = e.target.value;
                        const isAppleValid =
                          !appleValidation || checkAppleLink(appleValidation);
                        setIsAppleLinkValid(isAppleValid);
                      }}
                      placeholder="Please enter the link to the song or album on Apple Music."
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow-lg focus:outline-none focus:ring w-full ease-linear transition-all duration-150 mb-4"
                    />
                    <div style={{ marginTop: '12.86px' }}>
                      {!isAppleLinkValid && (
                        <span
                          className="text-red-500"
                          style={{ position: 'relative', bottom: '15px' }}
                        >
                          Please enter a valid link. It should start with:
                          https://music.apple.com/
                        </span>
                      )}
                    </div>
                  </div>
                </DialogContent>
                <DialogActions
                  style={{
                    height: 50,
                  }}
                >
                  <Button
                    autoFocus
                    onClick={handleClose}
                    className="bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
                  >
                    Cancel
                  </Button>
                  <Button
                    autoFocus
                    onClick={handleLinks}
                    disabled={isButtonDisable()}
                    className="bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
                    type="submit"
                  >
                    Update
                  </Button>
                </DialogActions>
              </form>
            </Dialog>
          </div>
        </Menu.Item>
      )}

      {!props.ele.isMultiple || props.transferToSellingPage ? (
        <Menu.Item className="py-2" key="2">
          <div className="flex items-center	">
            <SwapHorizIcon className="inline-block" />
            <p className="ml-3">
              <span className="font-normal block">Transfer NFT</span>
            </p>
          </div>
        </Menu.Item>
      ) : (
        <></>
      )}

      {showRedeemOption && (
        <Menu.Item className="py-2" key="5">
          <div className="flex items-center	">
            <DeleteIcon className="inline-block" />
            <p className="ml-3">
              <span className="font-normal block">Redeem 'burn' NFT</span>
            </p>
          </div>
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <>
      <div
        style={{ display: 'block' }}
        className="turning-screens-discover 2xl:w-2/12 xl:w-5/12 lg:w-3/12 md:w-4/12 "
        key={'collectionNFT' + props.index}
      >
        <div className="card" style={{ display: 'block' }}>
          <div className="card__cover" style={{ display: 'block' }}>
            <div
              onClick={() => {
                router.push('/nft/' + props.ele.tokenId);
              }}
              style={{ display: 'block' }}
              className="link-flex-res curosr-pointer"
            >
              <Slider {...settings}>
                {(() => {
                  if (!props.ele.icons || props.ele.icons.length === 0) {
                    return (
                      <div className="imgcover_con">
                        <img
                          src={
                            props.ele.icons && props.ele.icons[0]
                              ? props.ele.icons[0]
                              : '/img/cover/cover_260x260.jpg'
                          }
                          placeholder="/img/cover/cover_260x260.jpg"
                          className="card__image card_image_margin"
                        />
                      </div>
                    );
                  } else if (props.ele.nftType === 'Audio') {
                    return (
                      <AudioComponent nftData={props.ele} index={props.index} />
                    );
                  } else {
                    return (
                      props.ele.icons &&
                      props.ele.icons.map((ele, index) => {
                        return (
                          <div key={ele + index}>
                            {/* <div className="imgcover_con">
                                <img
                                  src={
                                    ele ? ele : '/img/cover/cover_260x260.jpg'
                                  }
                                  placeholder="/img/cover/cover_260x260.jpg"
                                  className="card__image card_image_margin"
                                />
                              </div> */}
                            <AspectRatio
                              ratio="1/1"
                              style={{
                                width: '100%',
                                borderRadius: '18px',
                              }}
                            >
                              <div className="flex w-full h-full">
                                <AspectRatio
                                  ratio="1/1"
                                  style={{
                                    width: '100%',
                                    borderRadius: '18px',
                                    position: 'relative',
                                  }}
                                >
                                  {' '}
                                  <div
                                    id={skeletonID}
                                    style={{ borderRadius: '18px' }}
                                    className="skeleton-moon  "
                                  />
                                </AspectRatio>

                                {ele.includes('_video') ? (
                                  <div
                                    className="top-0 left-0 w-full h-full object-cover"
                                    width="100%"
                                    height="100%"
                                    style={{
                                      position: 'absolute',
                                      borderRadius: '18px',
                                      overflow: 'hidden',
                                    }}
                                  >
                                    <ReactPlayer
                                      playsinline={true}
                                      height="100%"
                                      width="100%"
                                      url={ele}
                                      controls={true}
                                      playing={
                                        props.disableVideoAutoPlay
                                          ? false
                                          : true
                                      }
                                      muted={true}
                                      loop={true}
                                    />
                                  </div>
                                ) : (
                                  <img
                                    key={ele + 'imgNFTT'}
                                    alt={skeletonID}
                                    onLoad={showPic}
                                    src={
                                      ele
                                        ? isWebpSupported()
                                          ? ele
                                          : ele.replace(
                                              '_1500x1500',
                                              '_250x250',
                                            )
                                        : '/img/cover/cover_260x260.jpg'
                                    }
                                    placeholder="/img/cover/cover_260x260.jpg"
                                    // style={{borderRadius:'18px'}}
                                    className="top-0 left-0 w-full h-full object-cover"
                                    width="100%"
                                    height="100%"
                                    style={{
                                      position: 'absolute',
                                      borderRadius: '18px',
                                    }}
                                  />
                                )}
                              </div>
                            </AspectRatio>
                          </div>
                        );
                      })
                    );
                  }
                })()}
              </Slider>
              <span className="card__category">{props.ele.category}</span>
            </div>
          </div>
          <div className="card_padding">
            <div className=" pb-4">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {/* <Link prefetch={false} href={'/nft/' + props.ele.tokenId}>
                  <a style={{ display: 'block' }}>
                    <div className="card__title" style={{ marginBottom: 0 }}>
                      {props.ele.tokenName ? props.ele.tokenName : '-'}
                    </div>
                  </a>
                </Link> */}

                <Link prefetch={false} href={'/nft/' + props.ele?.tokenId}>
                  <Tooltip title={props.ele?.tokenName} classes={classes}>
                    <a style={{ display: 'block' }}>
                      <div
                        className="card__title relative"
                        style={{ marginBottom: 0 }}
                      >
                        <div
                          className="skeleton-moon"
                          style={{
                            opacity: props.ele?.tokenName
                              ? props.ele.tokenName === 'loading'
                                ? 1
                                : 0
                              : 1,
                            position: 'absolute',
                            width: 140,
                            height: 25,
                            borderRadius: 8,
                          }}
                        />

                        {props.ele?.tokenName
                          ? props.ele?.tokenName.length > 10
                            ? props.ele?.tokenName.substring(0, 10) + '...'
                            : props.ele?.tokenName
                          : '-'}
                      </div>
                    </a>
                  </Tooltip>
                </Link>

                {!props?.ele?.isRedeem && (
                  <div style={{ marginLeft: 'auto' }}>
                    <Dropdown
                      overlay={() => menuDropdown(props.index)}
                      placement="bottomCenter"
                      arrow
                      trigger={'click hover'}
                    >
                      <IconButton color="secondary" style={{ outline: 'none' }}>
                        <MoreVertIcon />
                      </IconButton>
                    </Dropdown>
                  </div>
                )}
              </div>

              <Link prefetch={false} href={'/nft/' + props.ele.tokenId}>
                <a style={{ display: 'block' }} className=" mt-4">
                  <>
                    <div
                      className="mt-2 flex items-center"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div className="">
                        <Link
                          prefetch={false}
                          href={'/nft/' + props.ele.tokenId}
                          key={'marketNFT' + props.index}
                        >
                          <a style={{ display: 'block' }}>
                            <div className="card__price card_price-wt">
                              <div className="card_head1">
                                <div>
                                  {props.ele.isMultiple &&
                                  !props.transferToSellingPage
                                    ? 'Starting from'
                                    : props.ele.nftSaleType &&
                                      props.ele.nftSaleType === 'Auctioning'
                                    ? 'Minimum bid'
                                    : 'Current price'}
                                </div>
                                {(() => {
                                  if (
                                    props.ele.nftSaleType &&
                                    props.ele.nftSaleType === 'Auctioning' &&
                                    (props.transferToSellingPage ||
                                      !props.ele.isMultiple)
                                  ) {
                                    return (
                                      <>
                                        {props.ele.nftSaleType &&
                                          props.ele.nftSaleType ===
                                            'Auctioning' && (
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                              }}
                                            >
                                              <div className="clock-svg">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  viewBox="0 0 24 24"
                                                >
                                                  <path d="M18.3,8.59l.91-.9a1,1,0,0,0-1.42-1.42l-.9.91a8,8,0,0,0-9.79,0l-.91-.92A1,1,0,0,0,4.77,7.69l.92.91A7.92,7.92,0,0,0,4,13.5,8,8,0,1,0,18.3,8.59ZM12,19.5a6,6,0,1,1,6-6A6,6,0,0,1,12,19.5Zm-2-15h4a1,1,0,0,0,0-2H10a1,1,0,0,0,0,2Zm3,6a1,1,0,0,0-2,0v1.89a1.5,1.5,0,1,0,2,0Z" />
                                                </svg>{' '}
                                              </div>

                                              <div className="card_head1Text">
                                                {Number(moment().format('x')) >=
                                                Number(
                                                  props.ele.auctionEndTime,
                                                ) ? (
                                                  <>Auction is ended</>
                                                ) : (
                                                  <>
                                                    {moment(
                                                      Number(
                                                        props.ele
                                                          .auctionEndTime,
                                                      ),
                                                    ).fromNow(true)}{' '}
                                                    left
                                                  </>
                                                )}
                                              </div>
                                            </div>
                                          )}
                                      </>
                                    );
                                  }
                                })()}
                              </div>
                              <span className="bsv-price-size ">
                                <h6 className="bsv_size_size mr-3">
                                  $
                                  {(() => {
                                    if (
                                      props.ele.isMultiple &&
                                      !props.transferToSellingPage
                                    ) {
                                      return props.ele.startingPrice
                                        ? props.ele.startingPrice.toFixed(2)
                                        : '-';
                                    } else {
                                      if (
                                        props.ele.nftSaleType &&
                                        props.ele.nftSaleType === 'Auctioning'
                                      ) {
                                        return props.ele.minBiddingPrice
                                          ? Number(
                                              props.ele.minBiddingPrice,
                                            ).toFixed(2)
                                          : '-';
                                      } else {
                                        return props.ele.price
                                          ? props.ele.price.toFixed(2)
                                          : '-';
                                      }
                                    }
                                  })()}
                                </h6>

                                <Tooltip title="BSV" classes={classes}>
                                  <div className="relative">
                                    <img
                                      className="mr-1 "
                                      style={{
                                        width: '14px',
                                        display: 'unset',
                                      }}
                                      src={'/img/bsvlogo.svg'}
                                    />
                                  </div>
                                </Tooltip>
                                <h6 className="bsv_size_size mr-3">
                                  {(() => {
                                    if (bsvRate) {
                                      if (
                                        props.ele.isMultiple &&
                                        !props.transferToSellingPage
                                      ) {
                                        let priceInBsv =
                                          Number(props.ele?.startingPrice) /
                                          bsvRate;

                                        return props.ele &&
                                          priceInBsv &&
                                          Number(priceInBsv) &&
                                          countDecimals(Number(priceInBsv)) &&
                                          countDecimals(Number(priceInBsv)) > 4
                                          ? Number(priceInBsv).toFixed(4)
                                          : props.ele && priceInBsv
                                          ? priceInBsv
                                          : '';
                                      } else {
                                        if (
                                          props.ele.nftSaleType &&
                                          props.ele.nftSaleType === 'Auctioning'
                                        ) {
                                          let priceInBsv =
                                            Number(props.ele?.minBiddingPrice) /
                                            bsvRate;

                                          return props.ele &&
                                            priceInBsv &&
                                            Number(priceInBsv) &&
                                            countDecimals(Number(priceInBsv)) &&
                                            countDecimals(Number(priceInBsv)) >
                                              4
                                            ? Number(priceInBsv).toFixed(4)
                                            : props.ele && priceInBsv
                                            ? priceInBsv
                                            : '';
                                        } else {
                                          let priceInBsv =
                                            Number(props.ele?.price) / bsvRate;

                                          return props.ele &&
                                            priceInBsv &&
                                            Number(priceInBsv) &&
                                            countDecimals(Number(priceInBsv)) &&
                                            countDecimals(Number(priceInBsv)) >
                                              4
                                            ? Number(priceInBsv).toFixed(4)
                                            : props.ele && priceInBsv
                                            ? priceInBsv
                                            : '';
                                        }
                                      }
                                    }
                                  })()}
                                </h6>
                              </span>
                            </div>
                          </a>
                        </Link>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexDirection: 'column',
                          marginLeft: 'auto',
                        }}
                      >
                        <div className="nft-numbering-collection">
                          {props.ele && props.ele.index
                            ? parseInt(props.ele.index)
                            : '1'}
                          /
                          {props.ele &&
                            props.ele.nftQuantity &&
                            parseInt(props.ele.nftQuantity)}
                        </div>

                        <div
                          style={{
                            marginLeft: 'auto',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <div
                            className={
                              props.ele.adminState === 'PENDING'
                                ? 'active-icon active-icon-pending'
                                : props.ele.adminState === 'REJECT'
                                ? 'active-icon active-icon-reject'
                                : props.ele.adminState === 'ACCEPT' &&
                                  props.ele.activeInMarketPlace
                                ? 'active-icon active-icon-active'
                                : 'active-icon active-icon-inactive'
                            }
                          ></div>
                          <p className="text-sm text-blueGray-500">
                            {(() => {
                              if (props.ele.adminState === 'PENDING') {
                                return 'Pending';
                              } else if (props.ele.adminState === 'REJECT') {
                                return 'Rejected';
                              } else if (
                                props.ele.adminState === 'ACCEPT' &&
                                props.ele.activeInMarketPlace
                              ) {
                                return 'Active';
                              } else if (
                                !props.ele.hasNftSold &&
                                !props.ele.activeInMarketPlace
                              ) {
                                return props.ele.isMultiple
                                  ? 'Not Active'
                                  : 'Not Active';
                              }
                            })()}

                            <div>{props.ele.isRedeem ? 'Redeemed' : null}</div>
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                </a>
              </Link>
            </div>

            <div
              className="p-4 border-t border-b text-xs text-gray-700"
              style={{
                display: 'flex',
                justifyContent: 'space-around',
              }}
            >
              <div className="flex items-center flex-col	">
                <FavoriteIcon
                  className="text-blueGray-500 mr-1 block mb-1"
                  style={{
                    height: 18,
                    width: 18,
                    display: 'block',
                  }}
                />
                <span className="block">
                  {props.ele.likes ? props.ele.likes : 0} Likes
                </span>
              </div>

              <div className="flex items-center flex-col	">
                <VisibilityIcon
                  className="text-blueGray-500 mr-1 block mb-1"
                  style={{
                    height: 18,
                    width: 18,
                    display: 'block',
                  }}
                />
                <span className="block">
                  {props.ele.views ? props.ele.views : 0} Views
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
